export default {
      id: "battery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#battery",
      toString: function () {
        return this.url;
      }
    }